module.exports = __webpack_public_path__ + "static/media/Human_ZG8447_720.0f9b4195.jpeg";